export const SituacaoKeys = {
  PreAvalicao: 'PreAvaliacao',
  Convidado: 'Convidado',
  CodigoExpirado: 'Expirado',
  Celular: 'Celular',
  DadosPessoais: 'DadosPessoais',
  Endereco: 'Endereco',
  Profissao: 'Profissao',
  Documento: 'Documento',
  Biometria: 'Biometria',
  DocumentoFrente: 'DocumentoFrente',
  DocumentoVerso: 'DocumentoVerso',
  CartaoDeCredito: 'CartaoDeCredito',
  Seguro: 'Seguro',
  SeguroFinalizado: 'SeguroFinalizado',
  Autorizacoes: 'Autorizacoes',
  Assinatura: 'Assinatura',
  Assinado: 'Assinado',
  Finalizado: 'Finalizado',
  Proposta: 'Proposta',
  Expirado: 'Expirado',
  Negada: 'Negada',
  Cancelada: 'Cancelada',
  Aprovada: 'Aprovada',
};
